import { VoiceModel } from '../Types';
import { StoreEnvironment } from '../Types/StoreTypes';
import requestClient from '../components/Utility/RequestClient';
import { store } from '../store';

const resolveDemo = () => (store.getState().environment as StoreEnvironment).demoInstance;

export const voiceModelService = {
    saveModel: async (type: string, data: any): Promise<any> => {
        return requestClient.post<VoiceModel>(`/voicemodel/${type}`, data);
    },

    getModels: (demo: boolean): Promise<{ data: { data: VoiceModel[] } }> => {
        return requestClient
            .get<{ data: VoiceModel[] }>(`${demo ? '/demo' : ''}/voicemodel/get`)
            .then((response: any) => response);
    },

    getModelsByPage: (
        page: number,
        itemsPerPage: number,
        additionalParams?: Record<string, any>,
        query?: string | null,
    ): Promise<{ data: { data: VoiceModel[]; total: number } }> => {
        return requestClient
            .get(`${resolveDemo() ? 'demo' : ''}/voicemodel/get`, {
                params: {
                    page,
                    itemsPerPage,
                    query,
                },
            })
            .then((response: any) => response);
    },

    getModel: async (modelIdentifier: string): Promise<{ data: VoiceModel }> => {
        return requestClient.get<VoiceModel>(`/voicemodel/get/${modelIdentifier}`);
    },

    deleteModel: async (identifier: string): Promise<any> => {
        return requestClient.delete(`/voicemodel/delete/${identifier}`);
    },
};
